import { Button, Form, FormFieldSelectInput } from '@/shared/components';
import {
  type AccessTypeSelectOption,
  type AuthenticationTypeSelectOption,
  type EditApiTokenFormValues,
} from '../model';
import { useTranslation } from 'react-i18next';
import type { UseFormReturn } from 'react-hook-form';

type Props = {
  form: UseFormReturn<EditApiTokenFormValues>;
  updateApiToken: () => Promise<void>;
  isPending: boolean;
  accessTypes: AccessTypeSelectOption[];
  authenticationTypes: AuthenticationTypeSelectOption[];
};

export const EditApiTokenForm = ({
  form,
  updateApiToken,
  isPending,
  accessTypes,
  authenticationTypes,
}: Props) => {
  const { t } = useTranslation();

  return (
    <Form {...form}>
      <form
        className="flex flex-col gap-[1.6rem]"
        onSubmit={form.handleSubmit(updateApiToken)}>
        <FormFieldSelectInput<AuthenticationTypeSelectOption>
          name="authenticationType"
          label={t('webApiTokens.fieldLabels.authenticationType')}
          items={authenticationTypes}
          renderItem={item => <div className="headline4">{item.label}</div>}
          renderSelectedValue={value => (
            <div className="headline4">
              {authenticationTypes.find(type => type.value === value)?.label}
            </div>
          )}
        />

        <FormFieldSelectInput<AccessTypeSelectOption>
          name="access"
          label={t('webApiTokens.fieldLabels.accessRights')}
          items={accessTypes}
          renderItem={item => <div className="headline4">{item.label}</div>}
          renderSelectedValue={value => (
            <div className="headline4">
              {accessTypes.find(type => type.value === value)?.label}
            </div>
          )}
        />

        <Button
          size="lg"
          type="submit"
          loading={isPending}
          className="mt-[1.6rem]">
          {t('webApiTokens.editing.submitButtonText')}
        </Button>
      </form>
    </Form>
  );
};
